import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const MegaphoneIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.50005 13.7002V15.5002C6.50005 16.8257 7.57457 17.9002 8.90005 17.9002C10.2255 17.9002 11.3 16.8257 11.3 15.5002V15.2421M7.58396 8.22394L18.317 3.77364C18.9755 3.50061 19.7 3.98455 19.7 4.69738V17.303C19.7 18.0158 18.9755 18.4998 18.317 18.2268L7.58396 13.7765C7.46255 13.7261 7.33239 13.7002 7.20095 13.7002H3.30005C2.74776 13.7002 2.30005 13.2525 2.30005 12.7002V9.3002C2.30005 8.74791 2.74776 8.3002 3.30005 8.3002H7.20095C7.33239 8.3002 7.46254 8.27428 7.58396 8.22394Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
